var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReviewed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8904 0C6.21913 0 0 6.21913 0 13.8908C0 21.5621 6.21913 27.7814 13.8904 27.7814C21.5617 27.7814 27.7809 21.5621 27.7809 13.8908C27.7809 6.21913 21.5617 0 13.8904 0Z",
    fill: "#43B02A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6583 8.15993C21.4452 7.94669 21.1011 7.94669 20.888 8.15993L10.3639 18.6832L6.93178 15.251C6.71871 15.0377 6.37288 15.0377 6.1598 15.251C5.94673 15.4639 5.94673 15.809 6.1598 16.0223L9.97871 19.8404C10.0852 19.9467 10.2246 20 10.3639 20C10.5032 20 10.6441 19.9467 10.7507 19.8404L21.6583 8.93108C21.8714 8.71801 21.8714 8.373 21.6583 8.15993Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewed);
export default __webpack_public_path__ + "static/media/reviewed.a8b831367ac28959e2fc831ff4f87380.svg";
export { ForwardRef as ReactComponent };